import React from 'react';

class ElapsedTimer extends React.Component {
  constructor(props) {
    super(props);

    this.interval = undefined;
    this.delay = 100;

    this.state = {
      elapsedTime: 0
    };
  }

  componentDidMount() {
    this.interval = setInterval(() => {
      const _elapsedTime = this.state.elapsedTime;
      const nextElapsedTime = (_elapsedTime + this.delay);
      (this.props.stop !== true) && this.setState({ elapsedTime: nextElapsedTime }, () => this.props.onUpdate({ elapsedTime: this.state.elapsedTime }));
    }, this.delay);
  }

  componentWillUnmount() {
    this.interval && clearInterval(this.interval);
  }

  render() {
    const minutes = Math.floor(this.state.elapsedTime / 1000 / 60);
    const seconds = ((this.state.elapsedTime - (minutes * 60 * 1000)) / 1000).toFixed(1);
    return (
      <span style={{ ...this.props.style }}>{minutes < 10 && 0}{minutes}:{seconds < 10 && 0}{seconds}</span>
    );
  }
}

export { ElapsedTimer };
